import $ from 'jquery';
import 'slick-carousel';

export function initServicesCarousel() {
    if (window.acf) {
        window.acf.addAction(
            'render_block_preview/type=services-carousel',
            servicesCarousel
        );
    }
}

export function servicesCarousel() {
    if (!document.querySelector('.services-slider-block')) return false;
    var sliderOptions = (() => {
        let el = document.querySelector('.services-slider-block');
        let optionsStr = el.getAttribute('data-slider-options');
        if (!el || !optionsStr) return false;

        let parsedJson = JSON.parse(optionsStr);
        return parsedJson;
    })();

    $('.services-slider-block__slider').slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: true,
        arrows: false,
        fade: sliderOptions['slider_type'] === 'fade',
        autoplay: true,
        autoplaySpeed: parseInt(sliderOptions['autoplay_duration'], 10) * 1000,
        responsive: [
            {
                breakpoint: 840,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                },
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 400,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    // Previous | Next Buttons
    Array.from(
        document.querySelectorAll('.services-slider-block__arrow')
    ).forEach(function (button) {
        button.addEventListener('click', function () {
            $('.services-slider-block__slider').slick(
                `slick${button.getAttribute('data-direction')}`
            );
        });
    });
}
